import commonService from "@/service/commonService";
import shijuanService from "@/service/shijuanService";

export const tagMixins = {
  data() {
    return {
      stages: [],
      stageId: 0,
      materials: [],
      materialId: 0,
      types: [],
      typeId: '',
      columnId: 0,
      columns: [],
      gradeId: '',
      grades: [],
      oldTypes: [],
      links: []
    }
  },
  methods: {
    async getStage() {
      try {
        let data = await commonService.fetchCommonStage();
        data = data.filter(item => {
          return [2, 3, 4].includes(item.id);
        });
        if (data && data.length > 0) {
          this.stageId = data[0].id;
          this.stages = data;
        } else {
          this.stages = [];
        }
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    async getMaterial() {
      try {
        let data = await commonService.common_tag_get('one');
        data = data.filter(item => {
          return item.name === '试卷';
        })
        if (data && data.length > 0) {
          this.materialId = data[0].id;
          this.materials = data;
        }
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    async getColumn() {
      try {
        let data = await commonService.common_tag_get('two', {
          typeId: this.materialId,
          stageId: this.stageId
        });
        if (data && data.length > 0) {
          this.columnId = data[0].id;
          this.columns = data;
        }
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    async getType() {
      try {
        let data = await commonService.common_tag_get('three');
        this.types = data || [];
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    async getOldType() {
      let params = {
        stageId: this.stageId
      }
      // if (this.stageId === 4) {
      //   params.gradeId = this.gradeId;
      // }
      // else {
      //   params.stageId = this.stageId;
      // }
      let data = await commonService.fetchCommonExamTypes(params);
      this.oldTypes = data;
    },
    // 获取关联关系
    async getColumnType() {
      if (!this.columnId) {
        this.links = [];
        return;
      }
      try {
        let data = await shijuanService.shijuan_column_type_get(this.columnId);
        if (data) {
          this.links = data.map(item => {
            return {
              ...item,
              name: item.detailType.name
            }
          });
        }
      } catch (e) {
        this.links = [];
        this.$message.error(e && e.msg);
      }
    },
    async getGrade() {
      try {
        let data = await commonService.fetchCommonGrade(this.stageId);
        if (data) {
          this.gradeId = data[0].id;
          this.grades = data;
        } else {
          this.grades = [];
        }
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    async changeTag(type) {
      this.resetTag(type);
      switch (type) {
        case 'stageId':
        case 'materialId':
          await this.getColumn();
          await this.getType();
          await this.getColumnType();
          break;
        case 'columnId':
          await this.getType();
          await this.getColumnType();
          break;
      }
    },
    resetTag(type) {
      switch (type) {
        case 'stageId':
        case 'materialId':
          this.columnId = 0;
          this.columns = [];
          this.types = [];
          this.typeId = '';
          this.links = [];
          break;
        case 'columnId':
          this.types = [];
          this.typeId = '';
          this.links = [];
          break;
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/layout/shijuan-manage/mixins/tagMixins.js